import cep from 'cep-promise';

const hasText = e => {
    if (e.target.value !== "") {
        e.target.classList.add('hasText');
    } else {
        e.target.classList.remove('hasText');
    }
}

const isEmail = str => {
    if(str.length > 0){
        const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
        return pattern.test(str);
    }
    return true;
}




const isCEP = cep => {
    const _cep = cep.replace(/\D/g, "");
    if (_cep.length === 8) {
        return true;
    }
    return false;
}

const openCorreios = _ => {
    window.open('https://buscacepinter.correios.com.br/app/endereco/index.php', '', '');
}

const isCPF = cpf => {
    if (typeof cpf !== "string") return false
    cpf = cpf.replace(/[\s.-]*/igm, '');
    if (
        !cpf ||
        cpf.length !== 11 ||
        cpf === "00000000000" ||
        cpf === "11111111111" ||
        cpf === "22222222222" ||
        cpf === "33333333333" ||
        cpf === "44444444444" ||
        cpf === "55555555555" ||
        cpf === "66666666666" ||
        cpf === "77777777777" ||
        cpf === "88888888888" ||
        cpf === "99999999999"
    ) {
        return false
    }
    var soma = 0
    var resto
    for (var i = 1; i <= 9; i++) {
        soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i)
    }
    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11)) resto = 0
    if (resto !== parseInt(cpf.substring(9, 10))) return false
    soma = 0
    for (var ii = 1; ii <= 10; ii++) {
        soma = soma + parseInt(cpf.substring(ii - 1, ii)) * (12 - ii)
    }
    resto = (soma * 10) % 11
    if ((resto === 10) || (resto === 11)) resto = 0
    if (resto !== parseInt(cpf.substring(10, 11))) return false
    return true;
}


const buscaEndereco = async str => {
    const result = await cep(str);
    return result;
}

const isDate = str => {
    if(str.length === 0) {
        return true;
    }
    const arr = str.split("/");
    if (arr.length === 3) {
        if (
            (arr[0].length === 2 && parseInt(arr[0]) >= 1 && parseInt(arr[0]) <= 31)
            &&
            (arr[1].length === 2 && parseInt(arr[1]) >= 1 && parseInt(arr[1]) <= 12)
            &&
            (arr[2].length === 4 && parseInt(arr[2]) >= 1800 && parseInt(arr[2]) <= 9999)
        ) {
            return true;
        }
    }
    return false;
}
const maskDate = e => {

    const pattern = /[^0-9]/gi;
    let value = e.target.value.replace(pattern, "");
    if (e.key !== 'Backspace') {

        const dateArr = [];
        for (let x = 1; x <= value.length; x++) {
            dateArr.push(value[x - 1]);
            if (x % 2 === 0 && x < 5) {
                dateArr.push("/");
            }
        }
        e.target.value = dateArr.join("");
    }
}

const isHour = str => {
    if(str.length === 0) {
        return true;
    }
    const arr = str.split(":");
    if (arr.length === 2) {
        if (
            (arr[0].length === 2 && parseInt(arr[0]) >= 0 && parseInt(arr[0]) <= 23)
            &&
            (arr[1].length === 2 && parseInt(arr[1]) >= 0 && parseInt(arr[1]) <= 59)
            
        ) {
            return true;
        }
    }
    return false;
}
const maskHour = e => {

    const pattern = /[^0-9]/gi;
    let value = e.target.value.replace(pattern, "");
    if (e.key !== 'Backspace') {

        const dateArr = [];
        for (let x = 1; x <= value.length; x++) {
            dateArr.push(value[x - 1]);
            if (x % 2 === 0 && x < 3) {
                dateArr.push(":");
            }
        }
        e.target.value = dateArr.join("");
    }
}

const randomNumbers = (qty=6) => {
    var arr = [];
    for(let n=1; n<=qty;n++){
        arr.push(random(0,9));
    }
    return arr.join("");
}

const random = (min,max) => {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

export const sumValuesArray = (values=[]) => {
    if(values.length > 0){
        return values.reduce((a, v) => (a+v));
    }
}

export { 
    hasText, 
    isCEP, 
    isEmail, 
    isCPF, 
    buscaEndereco, 
    maskDate, 
    maskHour,
    isDate,
    isHour,
    openCorreios,
    randomNumbers, 
    random
}